import React from 'react';
import {
 useLocation, useNavigate
} from 'react-router-dom';
import {
    Breadcrumb,
    BreadcrumbList,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from 'shared/components/ui/breadcrumb';
import {
 useDataBuilderV2
} from '../DataBuilderV2Context';

const routeLabels: Record<string, string> = {
    '': 'Dashboard',
    connections: 'Connections',
    workflows: 'Workflows',
    triggers: 'Triggers',
    security: 'Security',
    'api-keys': 'API Keys',
    settings: 'Settings',
};

const V2Breadcrumb: React.FC = () => {
    const {
 appFullName
} = useDataBuilderV2();
    const location = useLocation();
    const navigate = useNavigate();

    const v2Index = location.pathname.indexOf('/data-builder-v2');
    const afterV2 = v2Index !== -1
        ? location.pathname.slice(v2Index + '/data-builder-v2'.length)
        : '';
    const segments = afterV2.split('/').filter(Boolean);

    const currentSegment = segments[0] || '';
    const currentLabel = routeLabels[currentSegment] || currentSegment;

    const handleBackToApps = () => {
        navigate('../..', {
 relative: 'path'
});
    };

    const handleGoToDashboard = () => {
        navigate('.', {
 relative: 'path'
});
    };

    return (
        <Breadcrumb>
            <BreadcrumbList>
                <BreadcrumbItem>
                    <BreadcrumbLink className="cursor-pointer" onClick={handleBackToApps}>
                        Applications
                    </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                    {currentSegment ? (
                        <BreadcrumbLink className="cursor-pointer" onClick={handleGoToDashboard}>
                            {appFullName || 'Loading...'}
                        </BreadcrumbLink>
                    ) : (
                        <BreadcrumbPage>{appFullName || 'Loading...'}</BreadcrumbPage>
                    )}
                </BreadcrumbItem>
                {currentSegment && (
                    <>
                        <BreadcrumbSeparator />
                        <BreadcrumbItem>
                            <BreadcrumbPage>{currentLabel}</BreadcrumbPage>
                        </BreadcrumbItem>
                    </>
                )}
            </BreadcrumbList>
        </Breadcrumb>
    );
};

export default V2Breadcrumb;
